import { render, staticRenderFns } from "./MetasSettingView.vue?vue&type=template&id=5de91b96&scoped=true&"
import script from "./MetasSettingView.vue?vue&type=script&lang=ts&"
export * from "./MetasSettingView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de91b96",
  null
  
)

export default component.exports